/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_590d50a3"]'><div :class='["desc"]'><slot></slot></div></div></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_590d50a3"}'>
.desc
  font-size 12px
  color #4B4B4D
  line-height 18px
  margin-bottom 15px
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_590d50a3"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_590d50a3"}
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findex590d50a3%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Findex590d50a3%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_590d50a3"],
    ctorType: "component",
    outputPath: "components/index590d50a3/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>